import { type ReactNode } from 'react';

import { isDefined } from 'common';

import { ClinicalQuestionAssistantDefaultValueAdornment } from './DefaultValueAdornment';
import { BlockValueTemplateFieldArea } from '../../../../ConfigFields/CodeMirror/FlowTemplate';
import { useSelectedNodeField } from '../../../../ConfigFields/useSelectedNodeField';

interface ClinicalQuestionAssistantDefaultPromptFieldProps {
  defaultValue: string;
  fieldName: string;
  helperText: ReactNode;
  label: string;
}

export function ClinicalQuestionAssistantDefaultPromptField(
  props: ClinicalQuestionAssistantDefaultPromptFieldProps
) {
  const { defaultValue, fieldName, helperText, label } = props;
  const { setValue, value } = useSelectedNodeField<string | undefined>(fieldName);

  return (
    <BlockValueTemplateFieldArea
      fieldName={fieldName}
      label={label}
      helperText={helperText}
      fallbackValue={defaultValue}
      labelAdornment={
        <ClinicalQuestionAssistantDefaultValueAdornment
          displayedValue={value ?? defaultValue}
          valueState={isDefined(value) ? 'Customized' : 'UsingDefault'}
          resetValue={() => {
            setValue(undefined);
          }}
        />
      }
    />
  );
}
